package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import com.example.mystybag.sharedmodels.project.requestModels.merchant.BagAllergenItem
import kotlinx.serialization.Serializable

@Serializable
data class GetBagDetailsResponseModel(
    val bagId: Long? = null,
    val title: String? = null,
    val locationId: Long? = null,
    val locationName: String? = null,
    val availableCount: Int? = null,
    val reservedCount: Int? = null,
    val totalCount: Int? = null,
    val priceNormal: Double? = null,
    val priceWithDiscount: Double? = null,
    val currency: String? = null,
    val activeFrom: String? = null,
    val activeTo: String? = null,
    val isEnabled: Boolean? = null,
    /** Time from when order can be picked up (HH:mm). */
    val pickupTimeFrom: String? = null,
    /** Time until when order can be picked up (HH:mm). */
    val pickupTimeTo: String? = null,
    val createdAt: String? = null,
    val allergens: List<BagAllergenItem>? = null,
    val allergenIds: List<Long>? = null,
    /** How the bag's products were selected. */
    val productSelectionMode: BagProductSelectionMode = BagProductSelectionMode.ALL,
    /** Set when [productSelectionMode] == CATEGORY (legacy single-category field). */
    val productCategoryId: Long? = null,
    /** Set when [productSelectionMode] == CATEGORY (supports multiple categories). */
    val productCategoryIds: List<Long>? = null,
    /** The resolved products included in this bag. */
    val products: List<ProductModel> = emptyList(),
    val containsProductsForPersonsOver18: Boolean = false
) : BaseResponseModel()

